/* @flow weak */
import _ from 'lodash';

const GOOGLE_PLATFORM_JS = 'https://apis.google.com/js/client:platform.js';
const GOOGLE_CLIENT_ID = '648260376696-s7opre8oqbblsj80ght3tf86kvjifq98.apps.googleusercontent.com';

let loadId = null;

function load(callback) {
  if (window.gapi) {
    callback(window.gapi);
    return;
  }

  const $script = require('scriptjs');

  if (!loadId) {
    $script(GOOGLE_PLATFORM_JS, (loadId = _.uniqueId('gapi')));
  }

  $script.ready(loadId, function() {
    callback(window.gapi);
  });
}

/**
 * Initializes the Google API with an auth2 instance.
 * For more information, see: https://developers.google.com/identity/sign-in/web/reference
 */
function initWithAuthInstance(callback = function() {}) {
  load(function(gapi) {
    gapi.load('auth2', function() {
      let auth2 = gapi.auth2.getAuthInstance();
      if (!auth2) {
        auth2 = gapi.auth2.init({
          client_id: GOOGLE_CLIENT_ID,
          scope: 'https://www.googleapis.com/auth/plus.login',
          cookiepolicy: 'single_host_origin',
        });
      }
      callback(gapi);
    });
  });
}

/**
 * Fetches an authorization code for server-side authentication.
 * See https://developers.google.com/identity/sign-in/web/server-side-flow
 * @returns {Promise} that resolves with an authorization code
 */
function fetchAuthorizationCode() {
  return new Promise(function(resolve, reject) {
    const handleAuthResult = function(authResult) {
      const code = authResult.code;
      if (code) {
        resolve(code);
      } else {
        reject(new Error('GoogleAPI auth fetchAuthorizationCode failed'));
      }
    };

    initWithAuthInstance(function(gapi) {
      const auth2 = gapi.auth2.getAuthInstance();
      auth2.grantOfflineAccess({ redirect_uri: 'postmessage' })
        .then(handleAuthResult)
        .catch(e => console.error('GoogleAPI fetchAuthorizationCode failed', e));
    });
  });
}

/**
 * Signs out of the Google API auth2 instance
 */
function signOut() {
  initWithAuthInstance(function(gapi) {
    const auth2 = gapi.auth2.getAuthInstance();
    if (auth2.isSignedIn.get()) {
      auth2.signOut();
    }
  });
}

export default {
  initWithAuthInstance,
  fetchAuthorizationCode,
  signOut,
};



// WEBPACK FOOTER //
// ./src/lib/GoogleAPI.js